import { createCustomThemeSchema } from '@messenger/types'
import type { GetTheme, GetThemeNormalized } from '@messenger/types'
import axios from '@/api/axios.config'
import { z } from 'zod'

export const getCustomThemes = () => {
  return axios.get<GetThemeNormalized[]>('themes?custom_themes=true')
}

export const getCustomThemesById = (themeId: string) => {
  return axios.get<GetThemeNormalized>(`themes/${themeId}?custom=true`)
}

export const createCustomTheme = (
  payload: z.infer<typeof createCustomThemeSchema>,
) => {
  return axios.post<GetTheme>('createCustomTheme', payload)
}

/** @deprecated Backend route not implemented; remove usages or behind a feature flag. */
export const updateCustomTheme = (
  themeId: string,
  payload: Record<string, unknown>,
) => {
  return axios.patch(`themes/${themeId}`, payload)
}

/** @deprecated Backend route not implemented; remove usages or behind a feature flag. */
export const archiveCustomTheme = (themeId: string) => {
  return axios.patch(`archiveTheme/${themeId}`)
}

/** @deprecated Backend route not implemented; remove usages or behind a feature flag. */
export const uploadOptimizedThemeImage = (
  themeId: string,
  payload: Record<string, unknown>,
) => {
  return axios.post(`uploadOptimizedThemeImage/${themeId}`, payload, {
    headers: { 'content-type': 'form-data' },
  })
}

/** @deprecated Backend route not implemented; remove usages or behind a feature flag. */
export const uploadOptimizedReplacementImage = (
  layoutId: string,
  payload: Record<string, unknown>,
) => {
  return axios.post(`uploadOptimizedReplacementImage/${layoutId}`, payload, {
    headers: { 'content-type': 'form-data' },
  })
}

export const uploadEditedBackgroundImage = (
  layoutId: string,
  payload: Record<string, unknown>,
): Promise<{ location: string }> => {
  return axios.post(`uploadEditedBackgroundImage/${layoutId}`, payload, {
    headers: { 'content-type': 'form-data' },
  })
}

/** @deprecated Backend route not implemented; remove usages or behind a feature flag. */
export const deleteEditedBackgroundImage = (
  layoutId: string,
  payload: Record<string, unknown>,
) => {
  return axios.post(`deleteEditedBackgroundImage/${layoutId}`, payload)
}

/** @deprecated Backend route not implemented; remove usages or behind a feature flag. */
export const layoutForCustomThemes = async (
  productId: string,
  themeId: string,
) => {
  return await axios.get(
    `layoutsForCustomTheme?product_id=${productId}&theme_id=${themeId}`,
  )
}

/** @deprecated Backend route not implemented; remove usages or behind a feature flag. */
export const updateThemeOverride = async (
  themeOverrideId: string,
  payload: Record<string, unknown>,
) => {
  return await axios.patch(`themeOverrides/${themeOverrideId}`, payload)
}
